import { hospitalsTypes } from '../constantes/actionTypes'

const initialState = []

export const communities = (state = initialState, action) => {
  switch (action.type) {
    case hospitalsTypes.GET_ALL_COMMUNITIES_SUCCESS:
      return action.payload
    case hospitalsTypes.GET_ALL_COMMUNITIES_FAILURE:
      return initialState
    default:
      return state
  }
}
